import { useContext } from "react";

import { css } from "@emotion/react";

import FilterSeparator from "components/DesignComponents/FilterSeparator";
import Filters from "components/Filters";
import FilteredValues from "components/Filters/components/FilteredValues";
import Search from "components/Search";
import { useTableFunctions } from "components/Table/hooks/useTableFunctions";
import TableContext from "context/table/tableContext";
import { useMediaQueries } from "shared/hooks/useMediaQueries";

import Pagination from "./Pagination";
import TableView from "./TableView";

const Toolbar = () => {
    const {
        hasNoPermissionToRead,
        hasNoPagination,
        hideSearch,
        hideFilters,
        currentPage,
        rowsPerPage,
        totalRows,
        isInitialLoading
    } = useContext(TableContext);

    const { fromSm } = useMediaQueries();
    const { handlePageChange } = useTableFunctions();

    const hideFiltering = hideSearch && hideFilters;
    const showSeparator = fromSm && !hideSearch && !hideFilters;

    const justifyContent = hideFiltering ? "flex-end" : "space-between";

    return (
        <>
            <div
                css={css({
                    display: "flex",
                    alignItems: "center",
                    justifyContent,
                    rowGap: "16px",
                    columnGap: "16px",
                    padding: "16px 24px",

                    "& > div": {
                        display: "flex"
                    },

                    "@media(max-width: 839px)": {
                        flexDirection: "column",
                        alignItems: "flex-start",
                        justifyContent: "center",

                        "& > div": {
                            width: "100%"
                        }
                    }
                })}
            >
                {!hideFiltering && (
                    <div
                        css={css({
                            alignItems: "center",
                            width: "100%",

                            "@media(max-width: 599px)": {
                                flexDirection: "column",
                                alignItems: "flex-start"
                            }
                        })}
                    >
                        {!hideSearch && (
                            <Search isDisabled={hasNoPermissionToRead} />
                        )}

                        {showSeparator && (
                            <FilterSeparator width={1} height={36} />
                        )}

                        {!hideFilters && <Filters />}
                    </div>
                )}

                <div
                    css={css({
                        alignSelf: "flex-start",
                        alignItems: "center",
                        justifyContent: "flex-end",

                        "@media(max-width: 839px)": {
                            justifyContent: "space-between"
                        },

                        "@media(max-width: 599px)": {
                            flexDirection: "column",
                            alignItems: "flex-start"
                        }
                    })}
                >
                    {!hasNoPagination && (
                        <Pagination
                            page={currentPage}
                            total={totalRows}
                            perPage={rowsPerPage}
                            onChange={handlePageChange}
                            isInitialLoading={isInitialLoading}
                        />
                    )}

                    <TableView isInitialLoading={isInitialLoading} />
                </div>
            </div>

            <FilteredValues />
        </>
    );
};

export default Toolbar;
